import { ARBITRARY_ID_UI_STATE, DOMAIN_TYPE_ARBITRARY } from '../../../consts';
export var getUIState = function (state) { var _a; return ((_a = state.domain[DOMAIN_TYPE_ARBITRARY]) === null || _a === void 0 ? void 0 : _a[ARBITRARY_ID_UI_STATE]) || {}; };
